import { User, colors, spacing } from 'component-library';
import { useNavigate } from 'react-router';
import { useState } from 'react';
import { type TextType } from '#lib/HeaderMenu/types';
import { getOnboardingUrl } from '#lib/utils/environment';
import { routePathsAdmin } from '../../../routePaths/adminRoutePaths';
import { Link, LinkWrapper } from '../styles';

const UserProfileLink = ({ text, closeMenu }: { text: TextType; closeMenu: () => void }) => {
  const navigate = useNavigate();

  const [hover, setHover] = useState(false);

  const handleOnClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    void navigate(routePathsAdmin.PROFILE_DETAILS);
    closeMenu();
  };

  return (
    <LinkWrapper
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
    >
      <Link
        onClick={(e) => {
          handleOnClick(e);
        }}
        href={`${getOnboardingUrl()}profile`}
        data-testid="user-profile-link"
      >
        <User
          width={spacing.small}
          height={spacing.small}
          color={hover ? colors.primary.blue : colors.base.black}
        />

        <span>{text.userProfile}</span>
      </Link>
    </LinkWrapper>
  );
};

export default UserProfileLink;
